import { Formik } from "formik";
import * as yup from "yup";
import toast from "react-hot-toast";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  FormikInput,
  FormikSelect,
  FormikSearchSelect,
  FormikDate,
  FormikSearchSectionSelect,
  FormikTextArea,
} from "../../../components/formik-components";
import Common from "../../../helper/common";
import dayjs from "dayjs";
import { resetBooking } from "../../../store/bookingSlice";
import { useDispatch } from "react-redux";

// import "../../../assets/nascent.css";

import {
  IntCourtPriceMin,
  IntMax,
  IntMin,
  IntMinLevel,
  PaymentStatusEnum,
  PaymentTypeEnum,
  ResultStatus,
  ToCSharpFormat,
  DateminFormat,
  respEnum,
  SlotStatusEnum,
  ClubPrivacyTypeEnum,
  RoleEnum,
  AppUserSettingsTypeEnum,
  ImageFolderEnum,
  TaxTypeEnum,
} from "../../../constants/appConstant";

import { useNavigate } from "react-router-dom";
import AddCustomer from "../../clubCustomers/components/addCustomer";
import animationData from "../../../assets/json/lotties/noData.json";
import common from "../../../helper/common";
import { useQueryParams } from "../../../contexts/queryParamsContext";
import { ImagePlus } from "lucide-react";

const formValidations = yup.object({
  courtId: yup.object().required("Court is Requied"),
  playerId: yup.number().required("Customer is Required"),
  phone: yup.string().required("Phone is Required"),
  noofplayers: yup.number().required("Select # no of players"),
  courtcharges: yup
    .number()
    .required("Enter Court Price")
    .min(0, "Court price can't be negative")
    .max(IntMax),
  total: yup
    .number()
    .required("Total is required")
    .min(0, "Total can't be negative")
    .max(IntMax),
  receivedAmount: yup
    .number()
    .nullable() // Allows the value to be null initially
    .min(0, "Received Amount can't be negative")
    .test(
      "is-less-than-courtcharges",
      "Received Amount must be less than Court Price",
      function (value) {
        const { total } = this.parent; // Access sibling field values
        return value == null || value < total; // Allow null or less than courtcharges
      }
    ),
  // bookingDate: yup
  //     .date()
  //     .required("Booking Date is Required")
  //     .min(
  //         dayjs().subtract(2, "day").startOf("day").toDate(),
  //         "Booking Date cannot be earlier than 2 days"
  //     ),
  //.min(
  //  dayjs().subtract(24, "hours"),
  //  "Past Date should be within the last 24 hours"
  //),
  //.min(Common.Utility.today, "Date should be greater than previous date "),
  //.min(new Date(2024, 10, 5), "Date should be greater than previous date "),
  paymentStatus: yup.date().required("Payment Status is Requied"),
  startDateTime: yup
    .string()
    .required("Start Time is required")
    .test(
      "is-valid-time",
      "Start Time format should be in 00, 30 or 23:59 format",
      (value) => Common.Utility.CheckTime(value)
    )
    .matches(
      /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
      "Invalid time format (HH:mm)"
    ),

  endDateTime: yup
    .string()
    .required("End time is required")
    .test(
      "is-valid-time",
      "End Time format should be in 00, 30 23:59 format",
      (value) => Common.Utility.CheckTime(value)
    )
    .matches(
      /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
      "Invalid time format (HH:mm)"
    ),
  notes: yup.string().min(2).max(150),
});

export default function AddBooking({ onClose, bookingValues = {} }) {
  const [customerList, setCustomerList] = useState([]);
  const [allCustomerList, setallCustomerList] = useState([]);
  const [phoneList, setPhoneList] = useState([]);
  const [courtList, setCourtList] = useState([]);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [durationList, setDurationList] = useState([]);
  const [bookedSlots, setBookedSlots] = useState([]);
  let [offPeakRates, setOffPeakRates] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState(PaymentStatusEnum.Un_Paid);
  const [selectedCustomer, setSelectedCustomer] = useState(false);
  const [attachment, setAttachment] = useState();

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const animationRef = useRef();
  const lottieInstance = useRef(null);
  let offpeakcharges = [];
  const { params, setParams } = useQueryParams();
  let isRequested = false;
  const dispatch = useDispatch();

  const formInitialValue = {
    bookingDate: Common.moment().format(DateminFormat),
    courtId: undefined,
    phone: "",
    noofplayers: 4,
    discountType: "fix",
    percentage: "",
    taxType: null,
    tax_id: null,
    tax_percentage: null,
    tax_amount: null,
    ...bookingValues,
  };

  const getLottie = async () => {
    const lot = await import("lottie-web");

    // Destroy the existing animation if there is one
    if (lottieInstance.current) {
      lottieInstance.current.destroy();
    }

    // Create a new animation instance and store it in the ref
    lottieInstance.current = lot.default.loadAnimation({
      loop: true,
      autoplay: true,
      animationData: animationData,
      container: animationRef.current,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    });
  };

  const getButtonColor = (status) => {
    switch (status) {
      case SlotStatusEnum.Available:
        return { color: "success", variant: "soft" };
      case SlotStatusEnum.Booked:
        return { color: "destructive", variant: "soft" };
      case SlotStatusEnum.Club_Holiday:
        return { color: "warning", variant: "soft" };
      case SlotStatusEnum.Court_Holiday:
        return { color: "warning", variant: "soft" };
      default:
        return { color: "neutral", variant: "text" };
    }
  };

  const formikRef = useRef();
  useEffect(() => {
    getLottie();

    return () => {
      if (lottieInstance.current) {
        lottieInstance.current.destroy();
      }
    };
  }, [bookedSlots]);

  useEffect(() => {
    getCustomers();
    getCourts();
    getClubPaymentTypes();
    getoffPeakRates();
    getTaxList();
    //const storedState = JSON.parse(localStorage.getItem("offPeakRates"));
    //if (storedState) { setOffPeakRates(storedState.offPeakRates); offpeakcharges = storedState.offPeakRates }
    //else { getoffPeakRates(); }
  }, []);

  const getoffPeakRates = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetOffPeakRates"
    );
    const data = response?.data ?? [];
    setOffPeakRates(data ?? []);
    offpeakcharges = data;
    //const storageObject = { offPeakRates: data };
    //localStorage.setItem('offPeakRates', JSON.stringify(storageObject));
  };

  const getCustomers = async () => {
    return new Promise(async (res) => {
      debugger;
      const response = await Common.ApiService.getInstance().request(
        "ClubPlayersddl",
        {},
        "Get",
        false
      );
      const customerData = response?.data ?? [];

      const updatedCustomerList = [
        { id: null, name: "Select Customer", phone: "" },
        ...customerData.map((customer) => ({
          id: customer.id,
          name: customer.name,
          phone: customer.phone,
        })),
      ];

      const updatedPhoneList = [
        { id: null, name: "Select Phone", customerId: null },
        ...customerData.map((customer) => ({
          id: customer.phone,
          name: customer.phone,
          customerId: customer.id,
        })),
      ];

      global.log(updatedCustomerList);
      global.log("Phone List:", updatedPhoneList);
      setCustomerList(updatedCustomerList);
      setallCustomerList(updatedCustomerList);
      setPhoneList(updatedPhoneList);

      setTimeout(res, 1000);
    });
  };

  const getBookedSlots = async (courtId, date, duration = 60) => {
    if (!courtId || !date) return;

    let url = `CheckCourtAvailability?courtId=${courtId}&playDate=${date}&duration=${duration}`;

    const response = await Common.ApiService.getInstance().request(url);
    setBookedSlots(response?.data ?? []);
  };

  const getCourts = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetSportWiseCourtddl"
    );
    if (response?.status == respEnum.Success) {
      setCourtList(response?.data ?? []);
      setTimeout(() => {
        if (bookingValues?.courtId) {
          response?.data?.forEach((item) => {
            var court = item.options.find(
              (option) => option.value == bookingValues.courtId
            );
            if (court) {
              formikRef.current?.setFieldValue("courtId", court);
              handleCourtChange(court);
            }
          });
        }
      }, 500);
    }
  };

  const getClubPaymentTypes = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentTypes"
    );

    if (response?.status == respEnum.Success) {
      setPaymentTypeList(response?.data ?? []);
    }
  };


  const getTaxList = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetTaxList"
    );
    if (response?.status == respEnum.Success) {
      setTaxList(response?.data ?? []);
    }
  }
  const onSubmitData = async (d, action) => {
    debugger;
    let data = {
      ...d,
      courtId: d.courtId.value,
      playerId: +d.playerId,
      noofplayers: +d.noofplayers,
      clubAccountId: +d.clubAccountId?.value,
      paymentStatus: +d.paymentStatus,
      courtcharges: +d.courtcharges,
      receivedAmount: d.receivedAmount ? +d.receivedAmount : null,
      total: +d.total,
      discount: d.discount ? +d.discount : null,
      tax_percentage: d.tax_percentage ?? null,
      tax_id: d.tax_id ?? null,
      startDateTime: Common.moment(
        `${d.bookingDate} ${d.startDateTime}`
      ).format(ToCSharpFormat),
      endDateTime: Common.moment(`${d.bookingDate} ${d.endDateTime}`).format(
        ToCSharpFormat
      ),
    };

    if (data.startDateTime >= data.endDateTime) {
      toast.error("End time must be greater");
      return;
    }
    debugger;
    // Validation check
    // if (
    //   data.startDateTime < dayjs().subtract(24, "hours").toDate() ||
    //   data.endDateTime < dayjs().subtract(24, "hours").toDate()
    // ) {
    //   toast.error("Start Time and End time should be within the last 24 hours");
    //   return;
    // }

    if (
      dayjs(data.endDateTime).isBefore(
        dayjs().subtract(
          global.user.appUserSettings?.find(
            (setting) => setting.type === AppUserSettingsTypeEnum.Add_Booking
          )?.value || 48,
          "hours"
        )
      )
    ) {
      toast.error(
        `Start Time and End Time should not be older than the last ${global.appUserSettings?.find(
          (setting) => setting.type === AppUserSettingsTypeEnum.Add_Booking
        )?.value || 48
        } hours`
      );
      return;
    }

    // const tenDaysAgo = new Date();
    // tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);

    // if (data.startDateTime < tenDaysAgo || data.endDateTime < tenDaysAgo) {
    //     toast.error("Start Time and End Time should not be earlier than 10 days ago.");
    //     return;
    // }

    if (
      (data.paymentStatus == PaymentStatusEnum.Paid ||
        data.paymentStatus == PaymentStatusEnum.Partial_Paid) &&
      !data.clubAccountId
    ) {
      toast.error("Please Provide the Payment Account for payment");
      return;
    }

    if (
      data.paymentStatus === PaymentStatusEnum.Partial_Paid &&
      !data.receivedAmount
    ) {
      toast.error("Enter received amount for partial payment");
      return;
    }

    if (data.paymentStatus == PaymentStatusEnum.Paid) {
      data.receivedAmount = +data.total;
      data.remainingAmount = data.total - data.receivedAmount;
    } else if (data.paymentStatus == PaymentStatusEnum.Un_Paid) {
      data.clubAccountId = null;
    }

    if (attachment && attachment instanceof File) {
      const uploadFilePathType = ImageFolderEnum.upload;
      data.attachment = (
        await Common.Utility.handleFileUpload([attachment], uploadFilePathType)
      )[0].photo;
    }

    let response = await Common.ApiService.getInstance().request(
      "AddClubBooking",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status == ResultStatus.Success) {
      Common.showToast("Booking Created successfully!", "Success", "success");
      dispatch(resetBooking());
      onClose(true);
      setAttachment(null);
    }
  };

  const _onCustomerAdded = useCallback(async (id, phone) => {
    formikRef.current.setFieldValue("phone", phone);
    formikRef.current.setFieldValue("playerId", id);
    await getCustomers();
  }, []);

  const _addCustomer = useCallback(() => (
    <AddCustomer
      id={undefined}
      onClose={_onCustomerAdded}
      open={open}
      setOpen={setOpen}
      bookingModal={true}
    />
  ));

  const checkPricing = (startDateTime, endDateTime) => {
    if (formikRef.current?.values.courtId && startDateTime && endDateTime) {
      setTimeout(handleCourtCharges, 500);
    }
  };

  const getOverlapMinutes = (start1, end1, start2, end2) => {
    const parseTime = (timeStr) => {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    };
    const start1Mins = parseTime(start1);
    const end1Mins = parseTime(end1);
    const start2Mins = parseTime(start2);
    const end2Mins = parseTime(end2);
    const overlapStart = Math.max(start1Mins, start2Mins);
    const overlapEnd = Math.min(end1Mins, end2Mins);
    return Math.max(0, overlapEnd - overlapStart);
  };

  const handleCourtCharges = () => {
    const { courtId, startDateTime, endDateTime } = formikRef.current.values;
    const sportId = courtId?.sportId;
    let durations =
      courtId?.formats?.map((item) => ({
        id: item.value,
        name: item.label,
        charges: item.charges,
        duration: item.value,
      })) ?? [];

    const startTime = dayjs(`2024-01-01 ${startDateTime}`);
    const endTime = dayjs(`2024-01-01 ${endDateTime}`);
    let diffInMinutes = endTime.diff(startTime, "minute");

    // Adjust for special case if ends with 9
    const durationInMinutes = diffInMinutes % 10 === 9 ? diffInMinutes + 1 : diffInMinutes;

    // Filter off-peak rates
    if (!offPeakRates || offPeakRates.length <= 0) {
      offPeakRates = offpeakcharges;
    }

    const applicableOffPeak = offPeakRates.filter(rate => rate.sportId === sportId);

    const formattedStartTime = Common.Utility.ConvertToFullTime(startDateTime);
    const formattedEndTime = Common.Utility.ConvertToFullTime(endDateTime);

    let totalOffPeakMinutes = 0;
    let totalOffPeakCost = 0;

    for (const rate of applicableOffPeak) {
      const offPeakMinutes = getOverlapMinutes(formattedStartTime, formattedEndTime, rate.start, rate.end);

      if (offPeakMinutes > 0) {
        let changeOffPeakMinutes = offPeakMinutes;
        if (changeOffPeakMinutes % 10 === 9) changeOffPeakMinutes += 1;

        const perMinute = rate.amount / 60;

        totalOffPeakMinutes += changeOffPeakMinutes;
        totalOffPeakCost += changeOffPeakMinutes * perMinute;
      }
    }

    const peakMinutes = durationInMinutes - totalOffPeakMinutes;

    // Find matching peak duration
    let matchingDuration = durations.find(d => d.duration === peakMinutes);

    let peakCost = 0;

    if (matchingDuration) {
      // Exact duration exists
      peakCost = matchingDuration.charges;

    } else if (peakMinutes > 0) {

      // --------------------------------------------------
      // ✅ NEW RULE:
      // 1️⃣ Try to use 60-minute slot first
      // --------------------------------------------------
      let selectedSlot = durations.find(d => d.duration === 60);

      // --------------------------------------------------
      // 2️⃣ If 60 doesn't exist → use largest lower slot
      // --------------------------------------------------
      if (!selectedSlot) {

        const lowerSlots = durations.filter(d => d.duration <= peakMinutes);

        if (lowerSlots.length > 0) {
          selectedSlot = lowerSlots.reduce((a, b) =>
            a.duration > b.duration ? a : b
          );
        } else {
          // No lower slot exists → fallback to smallest slot
          selectedSlot = durations[0];
        }
      }

      // --------------------------------------------------
      // ✅ Prorated peak cost
      // peakMinutes ÷ selectedSlot.duration × selectedSlot.charges
      // --------------------------------------------------
      const multiplier = peakMinutes / selectedSlot.duration;
      peakCost = multiplier * selectedSlot.charges;
    }

    // Special case: if diff ends with 9 and peakMinutes === 1
    if (diffInMinutes % 10 === 9 && peakMinutes === 1) peakCost = 0;

    const totalCost = Math.round(totalOffPeakCost + peakCost);

    formikRef.current.setFieldValue("courtcharges", totalCost);
    handleCourtChargesChange(totalCost);
  };


  const setCourtCharges = (matchingDuration, durations, durationInMinutes) => {
    if (matchingDuration) {
      formikRef.current.setFieldValue("courtcharges", matchingDuration.charges);
      handleCourtChargesChange(matchingDuration.charges);
    } else {
      const chargesObj =
        durations.find((item) => item.duration === 60) ?? durations[0];
      const perMinuteCharges = chargesObj.charges / chargesObj.duration;
      formikRef.current.setFieldValue(
        "courtcharges",
        Math.trunc(perMinuteCharges * durationInMinutes)
      );
      handleCourtChargesChange(
        Math.trunc(perMinuteCharges * durationInMinutes)
      );
    }
  };

  const handleCourtChange = (selectedCourt) => {
    if (!selectedCourt || !formikRef.current) return;
    checkPricing(
      formikRef.current?.values.startDateTime,
      formikRef.current?.values.endDateTime
    );

    let durations =
      selectedCourt?.formats?.map((item) => ({
        id: item.value,
        name: item.label,
      })) ?? [];
    setDurationList(durations);

    getBookedSlots(
      selectedCourt.value,
      formikRef.current?.values.bookingDate,
      formikRef.current?.values.duration
    );
  };

  const handleSlotClick = (slot) => {
    if (slot.status == SlotStatusEnum.Booked) {
      setParams({
        ...params,
        bookingId: slot.bookingId,
      });
      navigate(`/app/bookingDetails`);
    } else if (slot.status == SlotStatusEnum.Available) {
      const formattedStartTime = Common.Utility.formatTimeToHHMM(slot.start);
      const formattedEndTime = Common.Utility.formatTimeToHHMM(slot.end);

      formikRef.current.setFieldValue("startDateTime", formattedStartTime);
      formikRef.current.setFieldValue("endDateTime", formattedEndTime);
      checkPricing(formattedStartTime, formattedEndTime);
    }
  };

  const handleDiscountChange = (value) => {
    if (value === "") {
      formikRef.current.setFieldValue("discount", "");
      formikRef.current.setFieldValue(
        "total",
        formikRef.current.values.courtcharges
      );
    } else if (
      value < IntMinLevel ||
      +value > +formikRef.current.values.courtcharges
    ) {
      toast.error(
        `Discount should be greater than 0 and less than court charges ${formikRef.current.values.courtcharges}.`
      );
      formikRef.current.setFieldValue("discount", "");
      formikRef.current.setFieldValue(
        "total",
        formikRef.current.values.courtcharges
      );
    } else {
      formikRef.current.setFieldValue("discount", value);
      const total = formikRef.current.values.courtcharges - value;
      formikRef.current.setFieldValue("total", total > 0 ? total : 0);
    }
  };

  const handlePercentageChange = (value) => {
    if (value === "") {
      formikRef.current.setFieldValue("percentage", "");
      formikRef.current.setFieldValue("discount", "");
      formikRef.current.setFieldValue(
        "total",
        formikRef.current.values.courtcharges
      );
    } else if (value > 100) {
      toast.error("Percentage cannot be greater than 100%");
      formikRef.current.setFieldValue("percentage", 100);
      value = 100;
    } else if (value < 0) {
      formikRef.current.setFieldValue("percentage", "");
      return;
    }

    if (value && formikRef.current.values.courtcharges) {
      formikRef.current.setFieldValue("percentage", value);
      const discountAmount = Math.round(
        (formikRef.current.values.courtcharges * value) / 100
      );
      formikRef.current.setFieldValue("discount", discountAmount);
      const total = formikRef.current.values.courtcharges - discountAmount;
      formikRef.current.setFieldValue("total", total > 0 ? total : 0);
    }
  };

  const handleCourtChargesChange = (value) => {
    debugger;
    if (value < IntMin && value != "") {
      formikRef.current.setFieldValue("courtcharges", IntMinLevel);
      formikRef.current.setFieldValue("total", IntMinLevel);
    } else if (value > IntMax) {
      toast.error(`Court charges cannot be greater than ${IntMax}`);
      formikRef.current.setFieldValue("courtcharges", "");
      formikRef.current.setFieldValue("total", "");
    } else {
      formikRef.current.setFieldValue("courtcharges", value);
      formikRef.current.setFieldValue("total", value);
    }
    formikRef.current.setFieldValue("discount", "");
  };

  const calculateInclusiveTaxAmount = (courtcharges, taxPercentage) => {
    if (!courtcharges || !taxPercentage) return 0;

    const baseAmount = courtcharges / (1 + taxPercentage / 100);
    const taxAmount = courtcharges - baseAmount;

    return Math.round(taxAmount);
  };


  return (
    <Formik
      initialValues={formInitialValue}
      validationSchema={formValidations}
      innerRef={formikRef}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={onSubmitData}
    >
      {(formikProps) => (
        <div className="md:grid md:grid-cols-3 mb-10 gap-2 space-y-3 md:space-y-0">
          <style>{`
        .react-tel-input .form-control {
          padding-left: 9px !important;
        }
      `}</style>
          <div className="col-span-1">
            <div className="md:grid md:grid-cols-1  gap-2  space-y-3 md:space-y-0">
              <div className="md:grid">
                <div className="md:grid md:grid-cols-2  gap-6 space-y-3 md:space-y-0">
                  <div className="flex flex-col gap-2">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"playerId"}
                      data={customerList}
                      placeholder={"Select"}
                      label={"Customer"}
                      labelButton={
                        global.myClub?.privacyType == ClubPrivacyTypeEnum.Public
                          ? _addCustomer
                          : null
                      }
                      onChange={(e) => {
                        //getBookedSlots(
                        //    formikProps.values.courtId?.value,
                        //    formikProps.values.bookingDate
                        //);
                        const selectedCustomer = customerList.find(
                          (customer) => customer.id == parseInt(e, 10)
                        );
                        if (selectedCustomer) {
                          setSelectedCustomer(true);
                          formikProps.setFieldValue(
                            "phone",
                            selectedCustomer.phone
                          );
                        } else {
                          formikProps.setFieldValue("phone", "");
                          setSelectedCustomer(false);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col  gap-2">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"phone"}
                      data={phoneList}
                      placeholder={"Select Phone"}
                      label={"Phone"}
                      onChange={(phoneValue) => {
                        const selectedPhone = phoneList.find(
                          (phone) => phone.id === phoneValue
                        );
                        if (selectedPhone && selectedPhone.customerId) {
                          formikProps.setFieldValue(
                            "playerId",
                            selectedPhone.customerId
                          );
                        } else {
                          formikProps.setFieldValue("playerId", null);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="md:grid">
                <div className="md:grid md:grid-cols-2  gap-6  space-y-3 md:space-y-0">
                  <div className="flex flex-col gap-3">
                    <FormikSearchSectionSelect
                      formikProps={formikProps}
                      name={"courtId"}
                      label={"Court"}
                      data={courtList}
                      onChange={(val) => handleCourtChange(val)}
                    />
                  </div>
                  <div className="flex flex-col sm-hidden gap-3">
                    <FormikSelect
                      formikProps={formikProps}
                      name={"duration"}
                      label={"Duration"}
                      data={durationList}
                      onChange={(val) => {
                        getBookedSlots(
                          formikProps.values.courtId?.value,
                          formikProps.values.bookingDate,
                          val
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <FormikDate
                formikProps={formikProps}
                name={"bookingDate"}
                type={"date"}
                label={"Booking Date"}
                onChange={(val) => {
                  getBookedSlots(
                    formikProps.values.courtId?.value,
                    val,
                    formikProps.values.duration
                  );
                }}
              />
              <div className="grid">
                <div className="grid grid-cols-2  gap-6  md:space-y-0">
                  <div className="flex flex-col gap-3">
                    <FormikInput
                      formikProps={formikProps}
                      name={"startDateTime"}
                      placeholder={"Start Time"}
                      label={"Start Time"}
                      type={"time"}
                      onBlur={(event) => {
                        if (event.target.value) {
                          Common.Utility.handleBlur(
                            event.target.value,
                            "start Time",
                            true
                          );
                        }
                      }}
                      onChange={(event) =>
                        checkPricing(event, formikProps.values.endDateTime)
                      }
                    />
                  </div>
                  <div className="flex flex-col gap-3">
                    <FormikInput
                      formikProps={formikProps}
                      name={"endDateTime"}
                      placeholder={"End Time"}
                      label={"End Time"}
                      type={"time"}
                      onBlur={(event) => {
                        if (event.target.value) {
                          Common.Utility.handleBlur(
                            event.target.value,
                            "end Time",
                            true
                          );
                        }
                      }}
                      onChange={(event) =>
                        checkPricing(formikProps.values.startDateTime, event)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="md:grid">
                <div className="md:grid md:grid-cols-2  gap-6 space-y-3 md:space-y-0">
                  <div className="flex flex-col  sm-hidden gap-3">
                    <FormikSelect
                      formikProps={formikProps}
                      name={"noofplayers"}
                      placeholder={"No of Players"}
                      label={"No of Player"}
                      data={[
                        { id: 2, name: 2 },
                        { id: 4, name: 4 },
                      ]}
                    />
                  </div>
                  <div className="flex flex-col gap-3">
                    <FormikInput
                      formikProps={formikProps}
                      name={"courtcharges"}
                      placeholder={"Court Charges"}
                      label={"Court Charges"}
                      type={"number"}
                      max={IntMax}
                      min={IntCourtPriceMin}
                      onChange={(value) => handleCourtChargesChange(value)}
                    />
                  </div>
                </div>
              </div>
              {taxList?.length > 0 && (
                <div className="md:grid">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">

                    {/* Tax Name (PRIMARY CONTROL) */}
                    <div className="flex flex-col gap-3">
                      <FormikSearchSelect
                        formikProps={formikProps}
                        name={"tax_id"}
                        label={"Tax"}
                        placeholder={"Select"}
                        data={taxList
                          .filter(tax => tax.isactive)
                          .map(tax => ({
                            id: tax.id,
                            name: tax.name,
                          }))
                        }
                        onChange={(value) => {
                          const selectedTax = taxList.find(t => t.id === value);

                          if (selectedTax) {
                            const courtcharges = formikProps.values.courtcharges;
                            const taxAmount = calculateInclusiveTaxAmount(
                              courtcharges,
                              selectedTax.percentage
                            );

                            formikProps.setFieldValue("taxType", selectedTax.type);
                            formikProps.setFieldValue("tax_percentage", selectedTax.percentage);
                            formikProps.setFieldValue("tax_amount", taxAmount);
                          } else {
                            formikProps.setFieldValue("taxType", null);
                            formikProps.setFieldValue("tax_percentage", null);
                            formikProps.setFieldValue("tax_amount", null);
                          }
                        }}
                      />
                    </div>

                    {/* Tax Type (AUTO DISPLAY) */}
                    <div className="flex flex-col gap-3">
                      <FormikInput
                        formikProps={formikProps}
                        name={"taxType"}
                        label={"Tax Type"}
                        value={
                          formikProps.values.taxType === TaxTypeEnum.Inclusive
                            ? "Inclusive"
                            : "Exclusive"
                        }
                        disabled
                      />
                    </div>

                    {/* Tax Percentage */}
                    <div className="flex flex-col gap-3">
                      <FormikInput
                        formikProps={formikProps}
                        name={"tax_percentage"}
                        label={"Tax %"}
                        disabled
                      />
                    </div>

                    {/* Tax Amount */}
                    <div className="flex flex-col gap-3">
                      <FormikInput
                        formikProps={formikProps}
                        name={"tax_amount"}
                        label={"Tax Amount"}
                        disabled
                      />
                    </div>

                  </div>
                </div>
              )}

              <div className="grid">
                <div
                  className={`grid gap-2 ${formikProps.values.discountType === "percentage"
                    ? "grid-cols-4"
                    : "grid-cols-3"
                    }`}
                >
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-0">
                      <label className="text-sm font-medium text-gray-700">
                        Disc Type
                      </label>
                      <div className="flex bg-gray-100 rounded-lg p-[5px] mt-2 w-fit">
                        <button
                          type="button"
                          className={`px-2 py-0 text-sm font-medium rounded-md transition-all duration-200 ${formikProps.values.discountType === "fix" ||
                            !formikProps.values.discountType
                            ? "bg-white shadow-sm border border-gray-200 text-gray-900"
                            : "text-gray-600 hover:text-gray-900"
                            }`}
                          onClick={() => {
                            formikProps.setFieldValue("discountType", "fix");
                            formikProps.setFieldValue("percentage", "");
                            formikProps.setFieldValue("discount", "");
                            formikProps.setFieldValue(
                              "total",
                              formikProps.values.courtcharges
                            );
                          }}
                        >
                          Fix
                        </button>
                        <button
                          type="button"
                          className={`px-2 py-0 text-sm font-medium rounded-md transition-all duration-200 ${formikProps.values.discountType === "percentage"
                            ? "bg-white shadow-sm border border-gray-200 text-gray-900"
                            : "text-gray-600 hover:text-gray-900"
                            }`}
                          onClick={() => {
                            formikProps.setFieldValue(
                              "discountType",
                              "percentage"
                            );
                            formikProps.setFieldValue("percentage", "");
                            formikProps.setFieldValue("discount", "");
                            formikProps.setFieldValue(
                              "total",
                              formikProps.values.courtcharges
                            );
                          }}
                        >
                          %
                        </button>
                      </div>
                    </div>
                  </div>
                  {formikProps.values.discountType === "percentage" && (
                    <div className="flex flex-col gap-3">
                      <FormikInput
                        formikProps={formikProps}
                        name={"percentage"}
                        placeholder={"Percentage"}
                        label={"Percentage"}
                        type={"number"}
                        max={100}
                        min={0}
                        onChange={(value) => handlePercentageChange(value)}
                        disabled={
                          formikProps.values.courtcharges === "" ||
                          formikProps.values.courtcharges == null
                        }
                      />
                    </div>
                  )}
                  <div className="flex flex-col gap-3">
                    <FormikInput
                      formikProps={formikProps}
                      name={"discount"}
                      placeholder={
                        formikProps.values.discountType === "percentage"
                          ? "Auto-calculated"
                          : "Discount"
                      }
                      label={"Discount"}
                      type={"number"}
                      max={formikProps.values.courtcharges}
                      min={IntMinLevel}
                      onChange={(value) => handleDiscountChange(value)}
                      disabled={
                        formikProps.values.discountType === "percentage" ||
                        formikProps.values.courtcharges === "" ||
                        formikProps.values.courtcharges == null
                      }
                    />
                  </div>
                  <div className="flex flex-col gap-3">
                    <FormikInput
                      formikProps={formikProps}
                      name={"total"}
                      label={"Total"}
                      placeholder={"Total"}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>

              <div className="grid">
                <div className="grid grid-cols-2  gap-6 ">
                  <div className="flex flex-col gap-3">
                    <FormikSelect
                      formikProps={formikProps}
                      name={"paymentStatus"}
                      placeholder={"Payment Status"}
                      label={"Payment Status"}
                      // data={Common.Utility.enumToArray(PaymentStatusEnum)}
                      data={[
                        { id: PaymentStatusEnum.Paid, name: "Paid" },
                        {
                          id: PaymentStatusEnum.Partial_Paid,
                          name: "Partial Paid",
                        },
                        { id: PaymentStatusEnum.Un_Paid, name: "Un Paid" },
                      ]}
                      onChange={(val) => {
                        formikProps.setFieldValue("paymentStatus", val);

                        if (val === PaymentStatusEnum.Paid) {
                          setPaymentStatus(PaymentStatusEnum.Paid);
                          formikProps.setFieldValue(
                            "clubAccountId",
                            formikProps.values.clubAccountId
                          );
                          formikProps.setFieldValue("receivedAmount", "");
                        } else if (val === PaymentStatusEnum.Partial_Paid) {
                          setPaymentStatus(PaymentStatusEnum.Partial_Paid);
                          formikProps.setFieldValue(
                            "clubAccountId",
                            formikProps.values.clubAccountId
                          );
                          formikProps.setFieldValue("receivedAmount", "");
                        } else {
                          setPaymentStatus(PaymentStatusEnum.Un_Paid);
                          formikProps.setFieldValue("clubAccountId", null);
                          formikProps.setFieldValue("receivedAmount", "");
                        }
                      }}
                    />
                  </div>
                  {formikProps.values.paymentStatus ===
                    PaymentStatusEnum.Partial_Paid && (
                      <>
                        <div className="flex flex-col gap-3">
                          <FormikInput
                            formikProps={formikProps}
                            name={"receivedAmount"}
                            placeholder={"Received Amount "}
                            label={"Received Amount"}
                            type={"number"}
                            disabled={
                              formikProps.values.paymentStatus !==
                              PaymentStatusEnum.Partial_Paid ||
                              formikProps.values.courtcharges === "" ||
                              formikProps.values.courtcharges == null
                            }
                            max={formikProps.values.courtcharges}
                            min={IntMinLevel}
                            onChange={(value) => {
                              if (value < IntMinLevel && value != "") {
                                formikProps.setFieldValue(
                                  "receivedAmount",
                                  IntMinLevel
                                );
                              } else if (+value >= +formikProps.values.total) {
                                toast.error(
                                  `Received Amount cannot be greater than or equal to ${formikProps.values.total}`
                                );
                                formikProps.setFieldValue("receivedAmount", "");
                              } else {
                                formikProps.setFieldValue(
                                  "receivedAmount",
                                  value
                                );
                              }
                            }}
                          />
                        </div>
                      </>
                    )}
                  <div className="flex flex-col gap-3">
                    {/* <FormikSelect
                      formikProps={formikProps}
                      name={"paymentType"}
                      placeholder={"Payment Type"}
                      label={"Payment Type"}
                      data={Common.Utility.enumToArray(PaymentTypeEnum)}
                      disabled={
                        formikProps.values.paymentStatus !==
                        PaymentStatusEnum.Paid
                      }
                    /> */}

                    <FormikSearchSectionSelect
                      formikProps={formikProps}
                      name={"clubAccountId"}
                      label={"Payment Account"}
                      data={paymentTypeList}
                      disabled={
                        formikProps.values.paymentStatus ==
                        PaymentStatusEnum.Un_Paid
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <Button
                  className="mt-5 mb-3"
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  disabled={formikProps.isSubmitting}
                  type="button"
                >
                  {" "}
                  {formikProps.isSubmitting ? "Saving..." : "Add Booking"}{" "}
                </Button>

                <Button
                  color="secondary"
                  className="mt-5 ml-5 "
                  onClick={onClose}
                  type="button"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>

          {/* No Slots Data */}
          {bookedSlots.length <= 0 && (
            <div className="col-span-2">
              <div className="px-0 md:px-3  py-6">
                <div className="grid grid-cols-1 gap-2 flex justify-center items-center">
                  <div className="no-data-icon-sty" ref={animationRef}></div>
                  <h5 className="text-md text-bold text-center mb-4">
                    Please select a court for available time slots.
                  </h5>
                </div>
              </div>
            </div>
          )}
          {/* No Slots Data End */}

          {bookedSlots.length > 0 && (
            <div className="col-span-2">
              <div
                className="px-3 py-6"
                style={{ height: "360px", overflowY: "auto" }}
              >
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                  {bookedSlots.map((bs, index) => {
                    const buttonProps = getButtonColor(bs.status);

                    return (
                      <Button
                        key={index}
                        {...buttonProps}
                        className="rounded text-xs"
                        onClick={() => handleSlotClick(bs)}
                      >
                        {Common.Utility.formatTimeToAMPM(bs.start)} -{" "}
                        {Common.Utility.formatTimeToAMPM(bs.end)}
                      </Button>
                    );
                  })}
                </div>
              </div>


              {/* <div className="mt-2 ml-5">
                <FormikTextArea
                  formikProps={formikProps}
                  name={"notes"}
                  placeholder={"Enter Note..."}
                  type={"textarea"}
                  label={"Note (if any)"}
                  maxLength={150}
                  min={2}
                />
              </div> */}



              <div className="flex gap-4">
                <div className="flex-[3] p-4 rounded-lg">
                  <FormikTextArea
                    formikProps={formikProps}
                    name={"notes"}
                    placeholder={"Enter Note..."}
                    type={"textarea"}
                    label={"Note (if any)"}
                    maxLength={150}
                    min={2}
                  />
                </div>

                <div className="flex-[1]  p-4 rounded-lg">

                  {(selectedCustomer && paymentStatus !== PaymentStatusEnum.Un_Paid) && (

                    <div className="flex justify-center ">
                      <div className="w-28 h-28 relative flex items-center justify-center border border-dashed rounded-lg">
                        {attachment ? (
                          <div className="relative w-full h-full flex items-center justify-center">
                            {/* Local preview */}
                            <a
                              href={URL.createObjectURL(attachment)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer hover:opacity-80 transition inline-block"
                            >
                              <img
                                src={URL.createObjectURL(attachment)}
                                alt="Receipt"
                                className="max-w-full max-h-full rounded"
                              />
                            </a>
                            {/* Remove button */}
                            <div className="absolute top-1 right-1 flex space-x-1">
                              <button
                                type="button"
                                className="bg-red-100 rounded-full p-1 shadow"
                                onClick={() => setAttachment(null)}
                              >
                                <span className="text-red-500 text-xs">X</span>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer text-gray-400 text-xs">
                            <ImagePlus className="w-6 h-6 mb-1" />
                            Payment Receipt
                            <br />
                            <span className="text-center">(If Any)</span>
                            <input
                              type="file"
                              className="hidden"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) setAttachment(file);
                              }}
                            />
                          </label>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </Formik>
  );
}
